/**
 * zehn-aip's doc agent panel in the editor's dock.
 *
 * The dock page (/agent-panel, inside Collabora's frame) frames the panel at
 * VITE_AIP_PANEL_URL and tells it which file is open (AipPanelFrame). No
 * sign-in crosses the frame: the panel signs the person in with zehn-aip's
 * own session.
 */

import { env } from '@/shared/utils/env';
import { originOf } from '@/shared/utils/collaboraOrigin.js';

// The editor header's Assistant button sits outside the editor frame: it asks
// the open editor (collabora-editor) to show or hide the dock.
export const ASSISTANT_TOGGLE = 'zehn-docs:toggle-assistant';

export function toggleAssistant() {
  window.dispatchEvent(new CustomEvent(ASSISTANT_TOGGLE));
}

/** The panel's URL, or null when this deployment does not use it (the dock then holds only Placeholders). */
export function aipPanelUrl() {
  const url = env('VITE_AIP_PANEL_URL');
  return originOf(url) ? url : null;
}
